import React, { useCallback, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { noEscChar, required } from '../../helpers/commonYupValidations';

const CommonDocumentCommentModal = ({ closeModal, isOpen, action, submitHandler, isLoading }) => {
    let delayedIntimationReason = localStorage.getItem('delayedIntimationReason') || action?.claimDetails?.delayedIntimationReason || "";
    const initialValues = {
        comment: '',
    };
    const validationSchema = Yup.object().shape({
        comment: Yup.string().matches(noEscChar("Comment").regex, noEscChar("Comment").msg).required(required("Comment").msg),
    });

    const handleSubmit = (values) => {
        submitHandler(values)
    }

    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            closeModal();
        }
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);


    return (
        <Modal isOpen={isOpen} backdrop={'static'}>
            <ModalHeader toggle={closeModal} >Add Comment</ModalHeader>

            <ModalBody>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ touched, errors, dirty }) =>
                        <Form role="form">
                            <ul className="fieldArrayBoxUI row">
                                <li>
                                    <div className="fieldArrayBox">
                                        <label htmlFor="comment" className="form-label">
                                            Comment *
                                        </label>
                                        <Field
                                            as="textarea"
                                            className={`form-control ${touched.comment && errors.comment ? 'is-invalid' : ''}`}
                                            name="comment"
                                            placeholder="Enter Comment"
                                            disabled={['Edit', 'View'].includes(action?.type)}
                                        />
                                        {errors.comment && touched.comment ? (
                                            <p className="errorMsg">{errors.comment}</p>) : null}
                                    </div>
                                </li>
                            </ul >
                            <ModalFooter className="border-0">
                                <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isLoading}>
                                    Submit
                                </Button>
                            </ModalFooter>
                        </Form>
                    }
                </Formik >
            </ModalBody >
        </Modal >
    );
};

export default CommonDocumentCommentModal;